import Cookies from 'universal-cookie';
import { initializeAndTrack } from 'gatsby-plugin-gdpr-cookies';
import { loadGTM } from './loadGTM';
import { loadHotjar } from './loadHotjar';

export const runOnConsent = (location?: Location) => {
  const cookies = new Cookies();

  if (
    cookies.get('gatsby-gdpr-google-tagmanager') === 'true' &&
    typeof window !== 'undefined' &&
    !!location
  ) {
    loadGTM(process.env.GATSBY_GOOGLE_TAG as string, 'dataLayer');
    initializeAndTrack(location);
    loadHotjar(6407386, 6);
  }
};
